/**
 * react-query keys shared across tabs.
 *
 * A key is a cache address. Two tabs fetching the same resource under two
 * different keys pay for two round trips and, worse, invalidate separately —
 * a seat moved on the Seating tab would leave the Export tab's copy stale.
 * Anything that reads one of these resources uses the builder here, so the
 * cache is one cache.
 *
 * The VALUE stored under a key is part of its contract: the tracker board is
 * cached as the raw `TrackerResult` (ok/failure), not the unwrapped board.
 * A second reader that stored the unwrapped shape under the same key would
 * hand the first reader an object with no `ok` field.
 */
export const trackerBoardKey = (groupId: string) => ['group-tracker', groupId];
export const seatingChartsKey = (groupId: string) => ['seating-charts', groupId];
export const seatingChartKey = (groupId: string, chartId: string) => ['seating-chart', groupId, chartId];
export const scheduledBroadcastsKey = (groupId: string) => ['group-scheduled-broadcasts', groupId];
